export enum CmsType{
    ROADMAP="Road Map",
    FAQ="FAQ"
}